import { FC } from 'react'
import { FormattedText, Modal, Typography } from 'src/modules/core/components'
import classes from './appointment-reschedule-modal.module.scss'

import type { AppointmentRescheduleModalProps } from './appointment-reschedule-modal.interface'

export const AppointmentRescheduleModal: FC<AppointmentRescheduleModalProps> = ({ onClose }) => {
  return (
    <Modal
      onClose={onClose}
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          <FormattedText id="settings.appointment.rescheduleModal.title" />
        </Typography>
      }
    >
      <div className={classes.modalContent}>
        <Typography variant="body" className={classes.modalText}>
          <FormattedText id="settings.appointment.rescheduleModal.description" html={true} />
        </Typography>
      </div>
    </Modal>
  )
}
